<template>
  <div class="default-layout">
    <AppHeader />
    
    <main>
      <slot></slot>
    </main>
    
    <!-- Desktop Footer - Hidden on mobile -->
    <div class="hidden md:block">
      <AppFooter />
    </div>
    
    <!-- Mobile Footer - Hidden on desktop -->
    <div class="block md:hidden">
      <AppFooterMobile />
    </div>
    
    <!-- Feedback Tab -->
    <FeedbackTab />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import AppFooterMobile from '@/components/layout/AppFooterMobile.vue';
import FeedbackTab from '@/components/chat/feedback/FeedbackTab.vue';

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppFooter,
    AppFooterMobile,
    FeedbackTab
  }
}
</script>

<style scoped>
.default-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

main {
  flex: 1;
  position: relative;
  z-index: 10;
}
</style> 